export const Role = {
    PATIENT: 'PATIENT',
    PROFESSIONAL: 'PROFESSIONAL'
}